import { defineStore } from "pinia";
import axios from "axios";

export const useOrderStore = defineStore({
  id: "order",
  persist: true,
  state: () => ({
    newOrderItems: {},
    itemQuantity: 0,
    totalPriceAllItems: 0,
  }),
  actions: {
    setNewOrderItems(id, item) {
      // Remove added item if no quantity is select so it doesn't appear in 'Order Summary' screen
      if (item.quantity == 0) {
        return delete this.newOrderItems[id];
      }

      this.newOrderItems[id] = item;
    },
    setItemQuantity(change) {
      this.itemQuantity = this.itemQuantity + change;
    },
    setTotalPriceAllItems(total) {
      this.totalPriceAllItems = total;
    },
    clearOrderStore() {
      this.newOrderItems = {};
      this.itemQuantity = 0;
      this.totalPriceAllItems = 0;
    },
    newOrderApi(data, token) {
      return new Promise((resolve, reject) => {
        axios
          .post(process.env.VUE_APP_BASE_URL_API + "app/order/newOrder", data, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
  },
});
